import React from "react";
import _Suggestions from "../../generic/_Suggestions";
import { Alert } from "react-bootstrap";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
const ShortUrls = (props) => {
  const { onChange, value } = props;
  const { values } = useFormikContext();
  const { listShortLinks } = values;

  const _onChange = (e) => {
    if (onChange) {
      onChange(value + " " + e);
    }
  };

  return (
    <div className="bg-white !px-4 !py-2 rounded-lg">
      <div className="flex items-center gap-2 my-2">
        <div className="text-xl font-bold text-gray-600">URLs Cortas</div>
      </div>
      <Alert variant="secondary" className="Notice">
        Selecciona URLs cortas que deseas utilizar en la campaña
      </Alert>
      <div className="grid grid-cols-1 gap-4">
        <_Suggestions
          placeholder="https://..."
          handleChange={_onChange}
          options={
            listShortLinks?.map((item) => ({
              value: item.shortlinks,
              label: item.displayname,
            })) || []
          }
        />
      </div>
    </div>
  );
};
ShortUrls.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
};
export default ShortUrls;
